import React from "react";
import DatePicker from "react-datepicker";
import { Col, Row } from "react-bootstrap";
import { parse, isValid } from "date-fns";

import { formatDateInput } from "../../utility";
import { EMPTY_STRING } from "../../../constants";
import { ClockIcon } from "../../../assets/icons/iconsProvider";
import { DATE_FORMAT } from "../../../system/globalEnums";

const NewDatePicker = ({
  IconImage,
  label,
  onDateChange,
  value,
  minDate,
  isDisabled = false,
  className,
  isFormik = false,
  name = EMPTY_STRING,
  setFieldValue = () => {},
  placeholderText = DATE_FORMAT.NEW_DATE_PICKER_COMPONENT,
  ...rest
}) => {
  const handleDateChange = (date) => {
    if (isFormik) {
      setFieldValue(name, date);
    } else {
      onDateChange(date);
    }
  };

  const handleRawChange = (e) => {
    const formatted = formatDateInput(e.target.value);

    // Update what's shown in the input
    e.target.value = formatted;

    // Only update the selected date when a complete valid date exists
    if (formatted.length === 10) {
      const parsed = parse(
        formatted,
        DATE_FORMAT.REACT_DATE_PICKER,
        new Date()
      );

      if (isValid(parsed)) {
        handleDateChange(parsed);
      }
    }
  };

  return (
    <Row className={`m-0 filter-datepicker ${className}`}>
      {label && <label className="field-label">{label}</label>}

      <Col className="p-0 position-relative">
        {IconImage && <ClockIcon className="date-icon-image-container" />}

        <DatePicker
          {...rest}
          selected={isFormik ? (value ? new Date(value) : null) : value}
          onChange={handleDateChange}
          onChangeRaw={handleRawChange}
          minDate={minDate}
          className={className}
          disabled={isDisabled}
          dateFormat={DATE_FORMAT.REACT_DATE_PICKER}
          placeholderText={placeholderText}
        />
      </Col>
    </Row>
  );
};

export default NewDatePicker;
